import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { UserService } from "src/app/services/user.service";
import { ToastrService } from "ngx-toastr";
import { ServerRoutes } from "src/app/ServerRoutes";
import { AuthService } from "src/app/services/actions/auth.service";
import idiomas from '../../../enums/idiomas'
import especialidades from '../../../enums/especialidades'
import abordagens from '../../../enums/abordagens'
import estados from '../../../enums/estados'
import generos from '../../../enums/generos'
import countryCodes from '../../../enums/country-codes'
import fusos from '../../../enums/fusos'
import crpStates from '../../../enums/crp-states'

@Component({
	selector: "app-perfil",
	templateUrl: "./perfil.component.html",
	styleUrls: ["./perfil.component.scss"],
})

export class PerfilComponent implements OnInit {
	dadosFormSubmitted = false
	crpStatesList: Array<any> = crpStates
	crpState: string = null
	crp: string = null

	dadosForm = new FormGroup({
		name: new FormControl('', Validators.required),
		email: new FormControl('', Validators.required),
		countryCode: new FormControl('', Validators.required),
		countryCodeWhats: new FormControl(''),
		cellphone: new FormControl('', Validators.required),
		cpf: new FormControl('', Validators.required),
		whatsApp: new FormControl('', Validators.required),
		crp: new FormControl(''),
		crpState: new FormControl(''),
		sex: new FormControl('', Validators.required),
		fusoHorario: new FormControl('', Validators.required),
	})

	get formFieldDados () {
		return this.dadosForm.controls
	}

	enderecoFormSubmitted = false

	enderecoForm = new FormGroup({
		street: new FormControl('', Validators.required),
		street_number: new FormControl('', Validators.required),
		state: new FormControl('', Validators.required),
		city: new FormControl('', Validators.required),
		zipcode: new FormControl('', Validators.required),
		complementary: new FormControl(),
		neighborhood: new FormControl('', Validators.required)
	})

	get formFieldEndereco () {
		return this.enderecoForm.controls
	}

	perfilFormSubmitted = false

	perfilForm = new FormGroup({
		apresentacao: new FormControl(),
		tipoProfissional: new FormControl('', Validators.required),
		especialidade: new FormControl(),
		idiomas: new FormControl(),
		abordagens: new FormControl()
	})

	get formFieldPerfil () {
		return this.perfilForm.controls
	}

	senhaFormSubmitted = false

	senhaForm = new FormGroup({
		oldPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
		newPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
		confirmNewPassword: new FormControl('', [Validators.required, Validators.minLength(8)])
	})

	get formFieldSenha () {
		return this.senhaForm.controls
	}

	profissional = {}
	profissionalImage
	endereco = {}
	bancario = {}
	botaoSalvarBancario = true
	doc
	foto
	arrayIdiomas = idiomas
	arrayEspecialidades = especialidades
	arrayAbordagens = abordagens
	estados = estados
	generos = generos
	countryCodes = countryCodes
	fusos = fusos
	isPsicanalista: Boolean = false

	constructor(
		private userService: UserService,
		private toastr: ToastrService,
		private routes: ServerRoutes,
		private authService: AuthService
	) {}

	ngOnInit() {
		this.userService.getPerfil().subscribe(
			(res) => {
				this.profissional = res["profissional"]

				let countryCode: any
				let whats: any
				let cell: any
				let whatsComplete: any
				let cellComplete: any
				let crpSplit: any

				if (this.profissional['whatsApp']) {
					whats = this.profissional['whatsApp']
					countryCode = whats.slice(0, 2)
					whatsComplete = whats.slice(2, whats.lenght)
					this.profissional['countryCodeWhats'] = countryCode
					this.profissional['whatsApp'] = whatsComplete.trim()
				}

				if (this.profissional['cellphone']) {
					cell = this.profissional['cellphone']
					countryCode = cell.slice(0, 2)
					cellComplete = cell.slice(2, cell.lenght)
					this.profissional['countryCode'] = countryCode
					this.profissional['cellphone'] = cellComplete.trim()
				}

				if (this.profissional['crp']) {
					crpSplit = this.profissional['crp']
					this.crpState = crpSplit.slice(0, 2)
					const crpVerify = this.crpStatesList.find(d => d.code === this.crpState)
					if (crpVerify) {
						this.profissional['crpState'] = this.crpState
					}
					this.crp = this.profissional['crp'] = crpSplit.slice(2, crpSplit.lenght)
				}

				this.dadosForm.patchValue(this.profissional)

				if (res["endereco"]) {
					this.enderecoForm.patchValue(res["endereco"])
				}

				if (this.profissional["especialidade"]) {
					this.profissional["especialidade"] = JSON.parse(this.profissional["especialidade"]);
				}

				if (this.profissional["abordagens"]) {
					this.profissional["abordagens"] = JSON.parse(this.profissional["abordagens"]);
				}

				if (this.profissional["idiomas"]) {
					this.profissional["idiomas"] = JSON.parse(this.profissional["idiomas"]);
				}

				this.perfilForm.patchValue(this.profissional)

				this.isPsicanalista = this.profissional['tipoProfissional'] === "Psicanalista";

				if (this.profissional["image"]) {
					this.profissionalImage = this.routes.server + "/client/photos/perfil/profissional/" + this.profissional["image"];
				} else {
					this.profissionalImage = false;
				}
			},
			(err) => console.log(err)
		);
	}

	onOptionsSelected(value: any){
		if (value === 'Psicanalista') return this.isPsicanalista = true;
		this.isPsicanalista = false;
	}

	updateSenha () {
		this.senhaFormSubmitted = true
		const senhaInfo = this.senhaForm.getRawValue()

		if (this.senhaForm.invalid) {
			this.toastr.warning('Dados de senha estão incorretos no formulário.', 'Atenção')
			return
		}

		if (senhaInfo['newPassword'] !== senhaInfo['confirmNewPassword']) {
			this.toastr.error('As senhas não conferem', 'Erro');
			return;
		}

		this.userService.editSenhaDadosPessoais(senhaInfo).subscribe(
			(res) => {
				this.toastr.success('Senha atualizada com sucesso', 'Sucesso');
				this.senhaFormSubmitted = false
				this.senhaForm.reset()
			},
			(err) => {
				this.toastr.error('Preencha os dados corretamente', 'Erro');
				console.log(err);
			}
		);
	}

	updateDados () {
		this.dadosFormSubmitted = true
		const dadosInfo = this.dadosForm.getRawValue()
		dadosInfo.cellphone = dadosInfo.countryCode + dadosInfo.cellphone;
		dadosInfo.whatsApp = dadosInfo.countryCodeWhats + dadosInfo.whatsApp;
		delete dadosInfo["countryCode"]
		delete dadosInfo["countryCodeWhats"]
		dadosInfo.crp = dadosInfo.crpState + dadosInfo.crp;
		delete dadosInfo.crpState

		if (this.dadosForm.invalid) {
			this.toastr.warning("Seus dados estão incorretos no formulário.", "Atenção")
			return
		}

		this.userService.editPerfilDadosPessoais(dadosInfo).subscribe(
			(res) => {
				this.toastr.success("Dados pessoais atualizado com sucesso", "Sucesso");
				this.dadosFormSubmitted = false
			},
			(err) => {
				this.toastr.error("Preencha os dados corretamente", "Erro");
				console.log(err);
			}
		);
	}

	updateEndereco () {
		this.enderecoFormSubmitted = true
		const dadosEndereco = this.enderecoForm.getRawValue()

		if (this.enderecoForm.invalid) {
			this.toastr.warning("Dados de endereço estão incorretos no formulário.", "Atenção")
			return
		}

		this.userService.editPerfilEndereco(dadosEndereco).subscribe(
			(res) => {
				this.toastr.success("Endereço atualizado com sucesso", "Sucesso");
				this.enderecoFormSubmitted = false
			},
			(err) => {
				this.toastr.error("Preencha os dados corretamente!", "Erro");
				console.log(err);
			}
		);
	}

	updatePerfil () {
		this.perfilFormSubmitted = true
		const dadosPerfil = this.perfilForm.getRawValue()

		if (this.perfilForm.invalid) {
			this.toastr.warning("Seus dados de perfil estão incorretos no formulário.", "Atenção")
			return
		}

		this.userService.editPerfil(dadosPerfil).subscribe(
			(res) => {
				this.toastr.success("Perfil atualizado com sucesso", "Sucesso");
				this.perfilFormSubmitted = true
			},
			(err) => {
				this.toastr.error("Preencha os dados corretamente!", "Erro");
				console.log(err);
			}
		);
	}

	verifyFileTypes(file) {
		return file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'application/pdf' || file.type === 'image/jpeg'
	}

	uploadFoto(files: FileList) {
		let reader = new FileReader();
		this.foto = files.item(0);
		if (!this.verifyFileTypes(this.foto)) {
			return this.toastr.error("Erro no formato do arquivo. Formatos aceitos: png, jpg, pdf e jpeg", "Erro");
		}
		reader.readAsDataURL(this.foto);
		reader.onload = () => {
			let result = reader.result + "";

			this.foto = {
				filename: this.foto.name,
				filetype: this.foto.type,
				value: result.split(",")[1],
			};

			this.userService.uploadImage(this.foto).subscribe(
				(res) => {
					this.profissionalImage = this.routes.server + "/client/photos/perfil/profissional/" + res
					this.toastr.success("Foto atualizada com sucesso!", "Sucesso");
				},
				(err) => {
					if (err.status = 413) {
						return this.toastr.error('O arquivo que você está tentando enviar é muito grande. Para continuar, por favor, diminua o tamanho do arquivo e tente novamente.', "Erro");
					}
					this.toastr.error("Erro no upload. Atente-se ao limite de 2mb", "Erro");
				}
			);
		};
	}

	uploadPerfilProfissional(files: FileList) {
		this.doc = "";
		let reader = new FileReader();
		this.doc = files.item(0);
		if (!this.verifyFileTypes(this.doc)) {
			return this.toastr.error("Erro no formato do arquivo. Formatos aceitos: png, jpg, pdf e jpeg", "Erro");
		}
		reader.readAsDataURL(files.item(0));
		reader.onload = () => {
			let result = reader.result + "";

			this.doc = {
				filename: this.doc.name,
				filetype: this.doc.type,
				value: result.split(",")[1],
				id: this.userService.getId(),
			};

			this.authService.uploadPerfilProfissional(this.doc).subscribe(
				(res) => {
					this.toastr.success("Perfil profissional: recebido com sucesso", "Sucesso");
					this.profissional["filePerfil"] = true;
				},
				(err) => {
					if (err.status = 413) {
						return this.toastr.error('O arquivo que você está tentando enviar é muito grande. Para continuar, por favor, diminua o tamanho do arquivo e tente novamente.', "Erro");
					}
					this.toastr.error(err.error, "Erro");
				}
			);
		};
	}

	uploadDocumento(files: FileList) {
		this.doc = "";
		let reader = new FileReader();
		this.doc = files.item(0);
		if (!this.verifyFileTypes(this.doc)) {
			return this.toastr.error("Erro no formato do arquivo. Formatos aceitos: png, jpg, pdf e jpeg", "Erro");
		}
		reader.readAsDataURL(this.doc);
		reader.onload = () => {
			let result = reader.result + "";

			this.doc = {
				filename: this.doc.name,
				filetype: this.doc.type,
				value: result.split(",")[1],
				id: this.userService.getId(),
			};

			this.authService.uploadDocumento(this.doc).subscribe(
				(res) => {
					this.toastr.success("Documento: recebido com sucesso", "Sucesso");
					this.profissional["fileDoc"] = true;
				},
				(err) => {
					if (err.status = 413) {
						return this.toastr.error('O arquivo que você está tentando enviar é muito grande. Para continuar, por favor, diminua o tamanho do arquivo e tente novamente.', "Erro");
					}
					this.toastr.error(err.error, "Erro");
				}
			);
		};
	}

	uploadCRP(files: FileList) {
		this.doc = "";
		let reader = new FileReader();
		this.doc = files.item(0);
		if (!this.verifyFileTypes(this.doc)) {
			return this.toastr.error("Erro no formato do arquivo. Formatos aceitos: png, jpg, pdf e jpeg", "Erro");
		}
		reader.readAsDataURL(this.doc);
		reader.onload = () => {
			let result = reader.result + "";

			this.doc = {
				filename: this.doc.name,
				filetype: this.doc.type,
				value: result.split(",")[1],
				id: this.userService.getId(),
			};

			this.authService.uploadCRP(this.doc).subscribe(
				(res) => {
					this.toastr.success("CRP: recebido com sucesso", "Sucesso");
					this.profissional["fileCrp"] = true;
				},
				(err) => {
					if (err.status = 413) {
						return this.toastr.error('O arquivo que você está tentando enviar é muito grande. Para continuar, por favor, diminua o tamanho do arquivo e tente novamente.', "Erro");
					}
					this.toastr.error(err.error, "Erro");
				}
			);
		};
	}
}
